import anime from "animejs";

export function toggleMenu() {
  const hamburger = document.querySelector('#hamburger');
  const mainMenu = document.querySelector('#main-menu');
  if (!mainMenu) return;

  const mq = window.matchMedia("(max-width: 768px)");

  let tlOpen = null;
  let tlClose = null;
  let clickHandler = null;

  function cleanupMobile() {
    if (clickHandler && hamburger) {
      hamburger.removeEventListener('click', clickHandler);
    }
    clickHandler = null;

    if (tlOpen) tlOpen.pause();
    if (tlClose) tlClose.pause();
    tlOpen = null;
    tlClose = null;
  }

  function setupMobile() {
    // Creá timelines solo 1 vez por modo
    tlOpen = anime.timeline({
      targets: mainMenu,
      easing: 'easeInOutSine',
      autoplay: false,
    }).add({
      height: ['0vh', '100vh'],
      delay: 10,
      duration: 1,
    }).add({
      opacity: [0, 1],
      duration: 300,
      delay: 100,
    });

    tlClose = anime.timeline({
      targets: mainMenu,
      easing: 'easeInOutSine',
      autoplay: false,
    }).add({
      opacity: [1, 0],
      duration: 300,
      delay: 0,
    }).add({
      height: ['100vh', '0vh'],
      delay: 100,
      duration: 1,
      complete: function () {
        mainMenu.classList.remove('active');
      },
    });

    // Un solo click handler, removible
    clickHandler = () => {
      if (!hamburger) return;

      document.body.classList.toggle('open');
      hamburger.classList.toggle('open');

      if (!mainMenu.classList.contains('active')) {
        mainMenu.classList.add('active');
        tlClose.pause();
        tlOpen.restart();
      } else {
        tlOpen.pause();
        tlClose.restart();
      }
    };

    if (hamburger) {
      hamburger.addEventListener('click', clickHandler);
    }
  }

  function setupDesktop() {
    // Reset de estado para desktop
    document.body.classList.remove('open');
    if (hamburger) hamburger.classList.remove('open');

    mainMenu.classList.remove('active');
    mainMenu.style.height = 'auto';
    mainMenu.style.opacity = '';
  }

  function applyMode() {
    // Siempre limpiá antes de rearmar
    cleanupMobile();

    if (mq.matches) {
      setupMobile();
    } else {
      setupDesktop();
    }
  }

  applyMode();

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", applyMode);
  } else {
    mq.addListener(applyMode);
  }
}
